import CloseIcon from '@mui/icons-material/Close';
import { Box, useTheme } from '@mui/material';
import { duration } from 'dayjs';
import { AnimatePresence, motion } from 'motion/react';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { useAnimationsDisabled } from '../../util/Animation';
import { GameBoardZIndex } from './GameBoardZIndex';

export const STRIKE_ANIM_DURATION = duration(2, 'seconds');

export const StrikeOverlay: FunctionComponent = () => {
	const theme = useTheme();
	const strikes = useGameplaySelector(gamePlayStore.selectors.strikes).strikes;
	const enabled = !useAnimationsDisabled();
	const [show, setShow] = useState(false);
	const prevStrikesRef = useRef(strikes);

	useEffect(function updateAnimation() {
		if (enabled && (strikes > prevStrikesRef.current)) {
			setShow(true);
		}
		prevStrikesRef.current = strikes;
	}, [strikes, enabled]);

	const yEnd = ['0', '-40%', '-30%', '-20%'].getSafe(strikes);

	// Anim steps are 1 scale-in, 2 stationary, 3 rolling/shrinking
	return <AnimatePresence>
		{show && <motion.div
			initial={{
				opacity: 0,
				scale: 0.5,
				x: '-50%',
				y: '-50%',
				rotate: 0,
			}}
			animate={{
				opacity: [0, 1, 1, 0],
				scale: [0.5, 1, 1, 0.1],
				x: ['-50%', '-50%', '-50%', '50%'],
				y: ['-50%', '-50%', '-50%', yEnd],
				rotate: [0, 0, 0, 180],
			}}
			transition={{
				duration: STRIKE_ANIM_DURATION.asSeconds(),
				times: [0, 0.2, 0.7, 1],
				ease: ['backOut', 'linear', 'anticipate'],
			}}
			onAnimationComplete={() => setShow(false)}
			style={{
				position: 'fixed',
				top: '50%',
				left: '50%',
				zIndex: GameBoardZIndex.Overlay,
			}}
		>
			<Box sx={{
				width: '750px',
				height: '750px',
				borderRadius: '50%',
				bgcolor: theme.palette.game.strikeActive,
				border: `16px solid ${theme.palette.game.white}`,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				boxShadow: '0 20px 60px rgba(211, 47, 47, 0.8)',
				pointerEvents: 'none',
			}}>
				<CloseIcon sx={{
					fontSize: '36rem',
					color: theme.palette.game.white,
					fontWeight: 'bold',
				}} />
			</Box>
		</motion.div>}
	</AnimatePresence>;
};
